import { render, staticRenderFns } from "./DrawingList.vue?vue&type=template&id=51035524&scoped=true"
import script from "./DrawingList.vue?vue&type=script&lang=js"
export * from "./DrawingList.vue?vue&type=script&lang=js"
import style0 from "./DrawingList.vue?vue&type=style&index=0&id=51035524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51035524",
  null
  
)

export default component.exports